module.exports =
  [
    {
      "flag": "AD".toLowerCase(),
      "emoji": "🇦🇩",
      "unicode": "U+1F1E6 U+1F1E9",
      "text": "Andorra",
      "value": "Andorra"
    },
    {
      "flag": "AE".toLowerCase(),
      "emoji": "🇦🇪",
      "unicode": "U+1F1E6 U+1F1EA",
      "text": "United Arab Emirates",
      "value": "United Arab Emirates"
    },
    {
      "flag": "AF".toLowerCase(),
      "emoji": "🇦🇫",
      "unicode": "U+1F1E6 U+1F1EB",
      "text": "Afghanistan",
      "value": "Afghanistan"
    },
    {
      "flag": "AG".toLowerCase(),
      "emoji": "🇦🇬",
      "unicode": "U+1F1E6 U+1F1EC",
      "text": "Antigua and Barbuda",
      "value": "Antigua and Barbuda"
    },
    {
      "flag": "AI".toLowerCase(),
      "emoji": "🇦🇮",
      "unicode": "U+1F1E6 U+1F1EE",
      "text": "Anguilla",
      "value": "Anguilla"
    },
    {
      "flag": "AL".toLowerCase(),
      "emoji": "🇦🇱",
      "unicode": "U+1F1E6 U+1F1F1",
      "text": "Albania",
      "value": "Albania"
    },
    {
      "flag": "AM".toLowerCase(),
      "emoji": "🇦🇲",
      "unicode": "U+1F1E6 U+1F1F2",
      "text": "Armenia",
      "value": "Armenia"
    },
    {
      "flag": "AO".toLowerCase(),
      "emoji": "🇦🇴",
      "unicode": "U+1F1E6 U+1F1F4",
      "text": "Angola",
      "value": "Angola"
    },
    {
      // "flag": "AQ".toLowerCase(),
      "emoji": "🇦🇶",
      "unicode": "U+1F1E6 U+1F1F6",
      "text": "Antarctica",
      "value": "Antarctica"
    },
    {
      "flag": "AR".toLowerCase(),
      "emoji": "🇦🇷",
      "unicode": "U+1F1E6 U+1F1F7",
      "text": "Argentina",
      "value": "Argentina"
    },
    {
      "flag": "AS".toLowerCase(),
      "emoji": "🇦🇸",
      "unicode": "U+1F1E6 U+1F1F8",
      "text": "American Samoa",
      "value": "American Samoa"
    },
    {
      "flag": "AT".toLowerCase(),
      "emoji": "🇦🇹",
      "unicode": "U+1F1E6 U+1F1F9",
      "text": "Austria",
      "value": "Austria"
    },
    {
      "flag": "AU".toLowerCase(),
      "emoji": "🇦🇺",
      "unicode": "U+1F1E6 U+1F1FA",
      "text": "Australia",
      "value": "Australia"
    },
    {
      "flag": "AW".toLowerCase(),
      "emoji": "🇦🇼",
      "unicode": "U+1F1E6 U+1F1FC",
      "text": "Aruba",
      "value": "Aruba"
    },
    {
      "flag": "AX".toLowerCase(),
      "emoji": "🇦🇽",
      "unicode": "U+1F1E6 U+1F1FD",
      "text": "Åland Islands",
      "value": "Åland Islands"
    },
    {
      "flag": "AZ".toLowerCase(),
      "emoji": "🇦🇿",
      "unicode": "U+1F1E6 U+1F1FF",
      "text": "Azerbaijan",
      "value": "Azerbaijan"
    },
    {
      "flag": "BA".toLowerCase(),
      "emoji": "🇧🇦",
      "unicode": "U+1F1E7 U+1F1E6",
      "text": "Bosnia and Herzegovina",
      "value": "Bosnia and Herzegovina"
    },
    {
      "flag": "BB".toLowerCase(),
      "emoji": "🇧🇧",
      "unicode": "U+1F1E7 U+1F1E7",
      "text": "Barbados",
      "value": "Barbados"
    },
    {
      "flag": "BD".toLowerCase(),
      "emoji": "🇧🇩",
      "unicode": "U+1F1E7 U+1F1E9",
      "text": "Bangladesh",
      "value": "Bangladesh"
    },
    {
      "flag": "BE".toLowerCase(),
      "emoji": "🇧🇪",
      "unicode": "U+1F1E7 U+1F1EA",
      "text": "Belgium",
      "value": "Belgium"
    },
    {
      "flag": "BF".toLowerCase(),
      "emoji": "🇧🇫",
      "unicode": "U+1F1E7 U+1F1EB",
      "text": "Burkina Faso",
      "value": "Burkina Faso"
    },
    {
      "flag": "BG".toLowerCase(),
      "emoji": "🇧🇬",
      "unicode": "U+1F1E7 U+1F1EC",
      "text": "Bulgaria",
      "value": "Bulgaria"
    },
    {
      "flag": "BH".toLowerCase(),
      "emoji": "🇧🇭",
      "unicode": "U+1F1E7 U+1F1ED",
      "text": "Bahrain",
      "value": "Bahrain"
    },
    {
      "flag": "BI".toLowerCase(),
      "emoji": "🇧🇮",
      "unicode": "U+1F1E7 U+1F1EE",
      "text": "Burundi",
      "value": "Burundi"
    },
    {
      "flag": "BJ".toLowerCase(),
      "emoji": "🇧🇯",
      "unicode": "U+1F1E7 U+1F1EF",
      "text": "Benin",
      "value": "Benin"
    },
    {
      // "flag": "BL".toLowerCase(),
      "emoji": "🇧🇱",
      "unicode": "U+1F1E7 U+1F1F1",
      "text": "Saint Barthélemy",
      "value": "Saint Barthélemy"
    },
    {
      "flag": "BM".toLowerCase(),
      "emoji": "🇧🇲",
      "unicode": "U+1F1E7 U+1F1F2",
      "text": "Bermuda",
      "value": "Bermuda"
    },
    {
      "flag": "BN".toLowerCase(),
      "emoji": "🇧🇳",
      "unicode": "U+1F1E7 U+1F1F3",
      "text": "Brunei Darussalam",
      "value": "Brunei Darussalam"
    },
    {
      "flag": "BO".toLowerCase(),
      "emoji": "🇧🇴",
      "unicode": "U+1F1E7 U+1F1F4",
      "text": "Bolivia",
      "value": "Bolivia"
    },
    {
      // "flag": "BQ".toLowerCase(),
      "emoji": "🇧🇶",
      "unicode": "U+1F1E7 U+1F1F6",
      "text": "Bonaire, Sint Eustatius and Saba",
      "value": "Bonaire, Sint Eustatius and Saba"
    },
    {
      "flag": "BR".toLowerCase(),
      "emoji": "🇧🇷",
      "unicode": "U+1F1E7 U+1F1F7",
      "text": "Brazil",
      "value": "Brazil"
    },
    {
      "flag": "BS".toLowerCase(),
      "emoji": "🇧🇸",
      "unicode": "U+1F1E7 U+1F1F8",
      "text": "Bahamas",
      "value": "Bahamas"
    },
    {
      "flag": "BT".toLowerCase(),
      "emoji": "🇧🇹",
      "unicode": "U+1F1E7 U+1F1F9",
      "text": "Bhutan",
      "value": "Bhutan"
    },
    {
      "flag": "BV".toLowerCase(),
      "emoji": "🇧🇻",
      "unicode": "U+1F1E7 U+1F1FB",
      "text": "Bouvet Island",
      "value": "Bouvet Island"
    },
    {
      "flag": "BW".toLowerCase(),
      "emoji": "🇧🇼",
      "unicode": "U+1F1E7 U+1F1FC",
      "text": "Botswana",
      "value": "Botswana"
    },
    {
      "flag": "BY".toLowerCase(),
      "emoji": "🇧🇾",
      "unicode": "U+1F1E7 U+1F1FE",
      "text": "Belarus",
      "value": "Belarus"
    },
    {
      "flag": "BZ".toLowerCase(),
      "emoji": "🇧🇿",
      "unicode": "U+1F1E7 U+1F1FF",
      "text": "Belize",
      "value": "Belize"
    },
    {
      "flag": "CA".toLowerCase(),
      "emoji": "🇨🇦",
      "unicode": "U+1F1E8 U+1F1E6",
      "text": "Canada",
      "value": "Canada"
    },
    {
      "flag": "CC".toLowerCase(),
      "emoji": "🇨🇨",
      "unicode": "U+1F1E8 U+1F1E8",
      "text": "Cocos (Keeling) Islands",
      "value": "Cocos (Keeling) Islands"
    },
    {
      "flag": "CD".toLowerCase(),
      "emoji": "🇨🇩",
      "unicode": "U+1F1E8 U+1F1E9",
      "text": "Congo (Democratic Republic of the)",
      "value": "Congo (Democratic Republic of the)"
    },
    {
      "flag": "CF".toLowerCase(),
      "emoji": "🇨🇫",
      "unicode": "U+1F1E8 U+1F1EB",
      "text": "Central African Republic",
      "value": "Central African Republic"
    },
    {
      "flag": "CG".toLowerCase(),
      "emoji": "🇨🇬",
      "unicode": "U+1F1E8 U+1F1EC",
      "text": "Congo",
      "value": "Congo"
    },
    {
      "flag": "CH".toLowerCase(),
      "emoji": "🇨🇭",
      "unicode": "U+1F1E8 U+1F1ED",
      "text": "Switzerland",
      "value": "Switzerland"
    },
    {
      "flag": "CI".toLowerCase(),
      "emoji": "🇨🇮",
      "unicode": "U+1F1E8 U+1F1EE",
      "text": "Côte D'Ivoire",
      "value": "Côte D'Ivoire"
    },
    {
      "flag": "CK".toLowerCase(),
      "emoji": "🇨🇰",
      "unicode": "U+1F1E8 U+1F1F0",
      "text": "Cook Islands",
      "value": "Cook Islands"
    },
    {
      "flag": "CL".toLowerCase(),
      "emoji": "🇨🇱",
      "unicode": "U+1F1E8 U+1F1F1",
      "text": "Chile",
      "value": "Chile"
    },
    {
      "flag": "CM".toLowerCase(),
      "emoji": "🇨🇲",
      "unicode": "U+1F1E8 U+1F1F2",
      "text": "Cameroon",
      "value": "Cameroon"
    },
    {
      "flag": "CN".toLowerCase(),
      "emoji": "🇨🇳",
      "unicode": "U+1F1E8 U+1F1F3",
      "text": "China",
      "value": "China"
    },
    {
      "flag": "CO".toLowerCase(),
      "emoji": "🇨🇴",
      "unicode": "U+1F1E8 U+1F1F4",
      "text": "Colombia",
      "value": "Colombia"
    },
    {
      "flag": "CR".toLowerCase(),
      "emoji": "🇨🇷",
      "unicode": "U+1F1E8 U+1F1F7",
      "text": "Costa Rica",
      "value": "Costa Rica"
    },
    {
      "flag": "CU".toLowerCase(),
      "emoji": "🇨🇺",
      "unicode": "U+1F1E8 U+1F1FA",
      "text": "Cuba",
      "value": "Cuba"
    },
    {
      "flag": "CV".toLowerCase(),
      "emoji": "🇨🇻",
      "unicode": "U+1F1E8 U+1F1FB",
      "text": "Cape Verde",
      "value": "Cape Verde"
    },
    {
      // "flag": "CW".toLowerCase(),
      "emoji": "🇨🇼",
      "unicode": "U+1F1E8 U+1F1FC",
      "text": "Curaçao",
      "value": "Curaçao"
    },
    {
      "flag": "CX".toLowerCase(),
      "emoji": "🇨🇽",
      "unicode": "U+1F1E8 U+1F1FD",
      "text": "Christmas Island",
      "value": "Christmas Island"
    },
    {
      "flag": "CY".toLowerCase(),
      "emoji": "🇨🇾",
      "unicode": "U+1F1E8 U+1F1FE",
      "text": "Cyprus",
      "value": "Cyprus"
    },
    {
      "flag": "CZ".toLowerCase(),
      "emoji": "🇨🇿",
      "unicode": "U+1F1E8 U+1F1FF",
      "text": "Czech Republic",
      "value": "Czech Republic"
    },
    {
      "flag": "DE".toLowerCase(),
      "emoji": "🇩🇪",
      "unicode": "U+1F1E9 U+1F1EA",
      "text": "Germany",
      "value": "Germany"
    },
    {
      "flag": "DJ".toLowerCase(),
      "emoji": "🇩🇯",
      "unicode": "U+1F1E9 U+1F1EF",
      "text": "Djibouti",
      "value": "Djibouti"
    },
    {
      "flag": "DK".toLowerCase(),
      "emoji": "🇩🇰",
      "unicode": "U+1F1E9 U+1F1F0",
      "text": "Denmark",
      "value": "Denmark"
    },
    {
      "flag": "DM".toLowerCase(),
      "emoji": "🇩🇲",
      "unicode": "U+1F1E9 U+1F1F2",
      "text": "Dominica",
      "value": "Dominica"
    },
    {
      "flag": "DO".toLowerCase(),
      "emoji": "🇩🇴",
      "unicode": "U+1F1E9 U+1F1F4",
      "text": "Dominican Republic",
      "value": "Dominican Republic"
    },
    {
      "flag": "DZ".toLowerCase(),
      "emoji": "🇩🇿",
      "unicode": "U+1F1E9 U+1F1FF",
      "text": "Algeria",
      "value": "Algeria"
    },
    {
      "flag": "EC".toLowerCase(),
      "emoji": "🇪🇨",
      "unicode": "U+1F1EA U+1F1E8",
      "text": "Ecuador",
      "value": "Ecuador"
    },
    {
      "flag": "EE".toLowerCase(),
      "emoji": "🇪🇪",
      "unicode": "U+1F1EA U+1F1EA",
      "text": "Estonia",
      "value": "Estonia"
    },
    {
      "flag": "EG".toLowerCase(),
      "emoji": "🇪🇬",
      "unicode": "U+1F1EA U+1F1EC",
      "text": "Egypt",
      "value": "Egypt"
    },
    {
      "flag": "EH".toLowerCase(),
      "emoji": "🇪🇭",
      "unicode": "U+1F1EA U+1F1ED",
      "text": "Western Sahara",
      "value": "Western Sahara"
    },
    {
      "flag": "ER".toLowerCase(),
      "emoji": "🇪🇷",
      "unicode": "U+1F1EA U+1F1F7",
      "text": "Eritrea",
      "value": "Eritrea"
    },
    {
      "flag": "ES".toLowerCase(),
      "emoji": "🇪🇸",
      "unicode": "U+1F1EA U+1F1F8",
      "text": "Spain",
      "value": "Spain"
    },
    {
      "flag": "ET".toLowerCase(),
      "emoji": "🇪🇹",
      "unicode": "U+1F1EA U+1F1F9",
      "text": "Ethiopia",
      "value": "Ethiopia"
    },
    {
      "flag": "EU".toLowerCase(),
      "emoji": "🇪🇺",
      "unicode": "U+1F1EA U+1F1FA",
      "text": "European Union",
      "value": "European Union"
    },
    {
      "flag": "FI".toLowerCase(),
      "emoji": "🇫🇮",
      "unicode": "U+1F1EB U+1F1EE",
      "text": "Finland",
      "value": "Finland"
    },
    {
      "flag": "FJ".toLowerCase(),
      "emoji": "🇫🇯",
      "unicode": "U+1F1EB U+1F1EF",
      "text": "Fiji",
      "value": "Fiji"
    },
    {
      "flag": "FK".toLowerCase(),
      "emoji": "🇫🇰",
      "unicode": "U+1F1EB U+1F1F0",
      "text": "Falkland Islands (Malvinas)",
      "value": "Falkland Islands (Malvinas)"
    },
    {
      "flag": "FM".toLowerCase(),
      "emoji": "🇫🇲",
      "unicode": "U+1F1EB U+1F1F2",
      "text": "Micronesia",
      "value": "Micronesia"
    },
    {
      "flag": "FO".toLowerCase(),
      "emoji": "🇫🇴",
      "unicode": "U+1F1EB U+1F1F4",
      "text": "Faroe Islands",
      "value": "Faroe Islands"
    },
    {
      "flag": "FR".toLowerCase(),
      "emoji": "🇫🇷",
      "unicode": "U+1F1EB U+1F1F7",
      "text": "France",
      "value": "France"
    },
    {
      "flag": "GA".toLowerCase(),
      "emoji": "🇬🇦",
      "unicode": "U+1F1EC U+1F1E6",
      "text": "Gabon",
      "value": "Gabon"
    },
    {
      "flag": "GB".toLowerCase(),
      "emoji": "🇬🇧",
      "unicode": "U+1F1EC U+1F1E7",
      "text": "United Kingdom",
      "value": "United Kingdom"
    },
    {
      "flag": "GD".toLowerCase(),
      "emoji": "🇬🇩",
      "unicode": "U+1F1EC U+1F1E9",
      "text": "Grenada",
      "value": "Grenada"
    },
    {
      "flag": "GE".toLowerCase(),
      "emoji": "🇬🇪",
      "unicode": "U+1F1EC U+1F1EA",
      "text": "Georgia",
      "value": "Georgia"
    },
    {
      "flag": "GF".toLowerCase(),
      "emoji": "🇬🇫",
      "unicode": "U+1F1EC U+1F1EB",
      "text": "French Guiana",
      "value": "French Guiana"
    },
    {
      // "flag": "GG".toLowerCase(),
      "emoji": "🇬🇬",
      "unicode": "U+1F1EC U+1F1EC",
      "text": "Guernsey",
      "value": "Guernsey"
    },
    {
      "flag": "GH".toLowerCase(),
      "emoji": "🇬🇭",
      "unicode": "U+1F1EC U+1F1ED",
      "text": "Ghana",
      "value": "Ghana"
    },
    {
      "flag": "GI".toLowerCase(),
      "emoji": "🇬🇮",
      "unicode": "U+1F1EC U+1F1EE",
      "text": "Gibraltar",
      "value": "Gibraltar"
    },
    {
      "flag": "GL".toLowerCase(),
      "emoji": "🇬🇱",
      "unicode": "U+1F1EC U+1F1F1",
      "text": "Greenland",
      "value": "Greenland"
    },
    {
      "flag": "GM".toLowerCase(),
      "emoji": "🇬🇲",
      "unicode": "U+1F1EC U+1F1F2",
      "text": "Gambia",
      "value": "Gambia"
    },
    {
      "flag": "GN".toLowerCase(),
      "emoji": "🇬🇳",
      "unicode": "U+1F1EC U+1F1F3",
      "text": "Guinea",
      "value": "Guinea"
    },
    {
      "flag": "GP".toLowerCase(),
      "emoji": "🇬🇵",
      "unicode": "U+1F1EC U+1F1F5",
      "text": "Guadeloupe",
      "value": "Guadeloupe"
    },
    {
      "flag": "GQ".toLowerCase(),
      "emoji": "🇬🇶",
      "unicode": "U+1F1EC U+1F1F6",
      "text": "Equatorial Guinea",
      "value": "Equatorial Guinea"
    },
    {
      "flag": "GR".toLowerCase(),
      "emoji": "🇬🇷",
      "unicode": "U+1F1EC U+1F1F7",
      "text": "Greece",
      "value": "Greece"
    },
    {
      "flag": "GS".toLowerCase(),
      "emoji": "🇬🇸",
      "unicode": "U+1F1EC U+1F1F8",
      "text": "South Georgia",
      "value": "South Georgia"
    },
    {
      "flag": "GT".toLowerCase(),
      "emoji": "🇬🇹",
      "unicode": "U+1F1EC U+1F1F9",
      "text": "Guatemala",
      "value": "Guatemala"
    },
    {
      "flag": "GU".toLowerCase(),
      "emoji": "🇬🇺",
      "unicode": "U+1F1EC U+1F1FA",
      "text": "Guam",
      "value": "Guam"
    },
    {
      "flag": "GW".toLowerCase(),
      "emoji": "🇬🇼",
      "unicode": "U+1F1EC U+1F1FC",
      "text": "Guinea-Bissau",
      "value": "Guinea-Bissau"
    },
    {
      "flag": "GY".toLowerCase(),
      "emoji": "🇬🇾",
      "unicode": "U+1F1EC U+1F1FE",
      "text": "Guyana",
      "value": "Guyana"
    },
    {
      "flag": "HK".toLowerCase(),
      "emoji": "🇭🇰",
      "unicode": "U+1F1ED U+1F1F0",
      "text": "Hong Kong",
      "value": "Hong Kong"
    },
    {
      "flag": "HM".toLowerCase(),
      "emoji": "🇭🇲",
      "unicode": "U+1F1ED U+1F1F2",
      "text": "Heard Island and Mcdonald Islands",
      "value": "Heard Island and Mcdonald Islands"
    },
    {
      "flag": "HN".toLowerCase(),
      "emoji": "🇭🇳",
      "unicode": "U+1F1ED U+1F1F3",
      "text": "Honduras",
      "value": "Honduras"
    },
    {
      "flag": "HR".toLowerCase(),
      "emoji": "🇭🇷",
      "unicode": "U+1F1ED U+1F1F7",
      "text": "Croatia",
      "value": "Croatia"
    },
    {
      "flag": "HT".toLowerCase(),
      "emoji": "🇭🇹",
      "unicode": "U+1F1ED U+1F1F9",
      "text": "Haiti",
      "value": "Haiti"
    },
    {
      "flag": "HU".toLowerCase(),
      "emoji": "🇭🇺",
      "unicode": "U+1F1ED U+1F1FA",
      "text": "Hungary",
      "value": "Hungary"
    },
    {
      "flag": "ID".toLowerCase(),
      "emoji": "🇮🇩",
      "unicode": "U+1F1EE U+1F1E9",
      "text": "Indonesia",
      "value": "Indonesia"
    },
    {
      "flag": "IE".toLowerCase(),
      "emoji": "🇮🇪",
      "unicode": "U+1F1EE U+1F1EA",
      "text": "Ireland",
      "value": "Ireland"
    },
    {
      "flag": "IL".toLowerCase(),
      "emoji": "🇮🇱",
      "unicode": "U+1F1EE U+1F1F1",
      "text": "Israel",
      "value": "Israel"
    },
    {
      // "flag": "IM".toLowerCase(),
      "emoji": "🇮🇲",
      "unicode": "U+1F1EE U+1F1F2",
      "text": "Isle of Man",
      "value": "Isle of Man"
    },
    {
      "flag": "IN".toLowerCase(),
      "emoji": "🇮🇳",
      "unicode": "U+1F1EE U+1F1F3",
      "text": "India",
      "value": "India"
    },
    {
      "flag": "IO".toLowerCase(),
      "emoji": "🇮🇴",
      "unicode": "U+1F1EE U+1F1F4",
      "text": "British Indian Ocean Territory",
      "value": "British Indian Ocean Territory"
    },
    {
      "flag": "IQ".toLowerCase(),
      "emoji": "🇮🇶",
      "unicode": "U+1F1EE U+1F1F6",
      "text": "Iraq",
      "value": "Iraq"
    },
    {
      "flag": "IR".toLowerCase(),
      "emoji": "🇮🇷",
      "unicode": "U+1F1EE U+1F1F7",
      "text": "Iran",
      "value": "Iran"
    },
    {
      "flag": "IS".toLowerCase(),
      "emoji": "🇮🇸",
      "unicode": "U+1F1EE U+1F1F8",
      "text": "Iceland",
      "value": "Iceland"
    },
    {
      "flag": "IT".toLowerCase(),
      "emoji": "🇮🇹",
      "unicode": "U+1F1EE U+1F1F9",
      "text": "Italy",
      "value": "Italy"
    },
    {
      // "flag": "JE".toLowerCase(),
      "emoji": "🇯🇪",
      "unicode": "U+1F1EF U+1F1EA",
      "text": "Jersey",
      "value": "Jersey"
    },
    {
      "flag": "JM".toLowerCase(),
      "emoji": "🇯🇲",
      "unicode": "U+1F1EF U+1F1F2",
      "text": "Jamaica",
      "value": "Jamaica"
    },
    {
      "flag": "JO".toLowerCase(),
      "emoji": "🇯🇴",
      "unicode": "U+1F1EF U+1F1F4",
      "text": "Jordan",
      "value": "Jordan"
    },
    {
      "flag": "JP".toLowerCase(),
      "emoji": "🇯🇵",
      "unicode": "U+1F1EF U+1F1F5",
      "text": "Japan",
      "value": "Japan"
    },
    {
      "flag": "KE".toLowerCase(),
      "emoji": "🇰🇪",
      "unicode": "U+1F1F0 U+1F1EA",
      "text": "Kenya",
      "value": "Kenya"
    },
    {
      "flag": "KG".toLowerCase(),
      "emoji": "🇰🇬",
      "unicode": "U+1F1F0 U+1F1EC",
      "text": "Kyrgyzstan",
      "value": "Kyrgyzstan"
    },
    {
      "flag": "KH".toLowerCase(),
      "emoji": "🇰🇭",
      "unicode": "U+1F1F0 U+1F1ED",
      "text": "Cambodia",
      "value": "Cambodia"
    },
    {
      "flag": "KI".toLowerCase(),
      "emoji": "🇰🇮",
      "unicode": "U+1F1F0 U+1F1EE",
      "text": "Kiribati",
      "value": "Kiribati"
    },
    {
      "flag": "KM".toLowerCase(),
      "emoji": "🇰🇲",
      "unicode": "U+1F1F0 U+1F1F2",
      "text": "Comoros",
      "value": "Comoros"
    },
    {
      "flag": "KN".toLowerCase(),
      "emoji": "🇰🇳",
      "unicode": "U+1F1F0 U+1F1F3",
      "text": "Saint Kitts and Nevis",
      "value": "Saint Kitts and Nevis"
    },
    {
      "flag": "KP".toLowerCase(),
      "emoji": "🇰🇵",
      "unicode": "U+1F1F0 U+1F1F5",
      "text": "North Korea",
      "value": "North Korea"
    },
    {
      "flag": "KR".toLowerCase(),
      "emoji": "🇰🇷",
      "unicode": "U+1F1F0 U+1F1F7",
      "text": "South Korea",
      "value": "South Korea"
    },
    {
      "flag": "KW".toLowerCase(),
      "emoji": "🇰🇼",
      "unicode": "U+1F1F0 U+1F1FC",
      "text": "Kuwait",
      "value": "Kuwait"
    },
    {
      "flag": "KY".toLowerCase(),
      "emoji": "🇰🇾",
      "unicode": "U+1F1F0 U+1F1FE",
      "text": "Cayman Islands",
      "value": "Cayman Islands"
    },
    {
      "flag": "KZ".toLowerCase(),
      "emoji": "🇰🇿",
      "unicode": "U+1F1F0 U+1F1FF",
      "text": "Kazakhstan",
      "value": "Kazakhstan"
    },
    {
      "flag": "LA".toLowerCase(),
      "emoji": "🇱🇦",
      "unicode": "U+1F1F1 U+1F1E6",
      "text": "Lao People's Democratic Republic",
      "value": "Lao People's Democratic Republic"
    },
    {
      "flag": "LB".toLowerCase(),
      "emoji": "🇱🇧",
      "unicode": "U+1F1F1 U+1F1E7",
      "text": "Lebanon",
      "value": "Lebanon"
    },
    {
      "flag": "LC".toLowerCase(),
      "emoji": "🇱🇨",
      "unicode": "U+1F1F1 U+1F1E8",
      "text": "Saint Lucia",
      "value": "Saint Lucia"
    },
    {
      "flag": "LI".toLowerCase(),
      "emoji": "🇱🇮",
      "unicode": "U+1F1F1 U+1F1EE",
      "text": "Liechtenstein",
      "value": "Liechtenstein"
    },
    {
      "flag": "LK".toLowerCase(),
      "emoji": "🇱🇰",
      "unicode": "U+1F1F1 U+1F1F0",
      "text": "Sri Lanka",
      "value": "Sri Lanka"
    },
    {
      "flag": "LR".toLowerCase(),
      "emoji": "🇱🇷",
      "unicode": "U+1F1F1 U+1F1F7",
      "text": "Liberia",
      "value": "Liberia"
    },
    {
      "flag": "LS".toLowerCase(),
      "emoji": "🇱🇸",
      "unicode": "U+1F1F1 U+1F1F8",
      "text": "Lesotho",
      "value": "Lesotho"
    },
    {
      "flag": "LT".toLowerCase(),
      "emoji": "🇱🇹",
      "unicode": "U+1F1F1 U+1F1F9",
      "text": "Lithuania",
      "value": "Lithuania"
    },
    {
      "flag": "LU".toLowerCase(),
      "emoji": "🇱🇺",
      "unicode": "U+1F1F1 U+1F1FA",
      "text": "Luxembourg",
      "value": "Luxembourg"
    },
    {
      "flag": "LV".toLowerCase(),
      "emoji": "🇱🇻",
      "unicode": "U+1F1F1 U+1F1FB",
      "text": "Latvia",
      "value": "Latvia"
    },
    {
      "flag": "LY".toLowerCase(),
      "emoji": "🇱🇾",
      "unicode": "U+1F1F1 U+1F1FE",
      "text": "Libya",
      "value": "Libya"
    },
    {
      "flag": "MA".toLowerCase(),
      "emoji": "🇲🇦",
      "unicode": "U+1F1F2 U+1F1E6",
      "text": "Morocco",
      "value": "Morocco"
    },
    {
      "flag": "MC".toLowerCase(),
      "emoji": "🇲🇨",
      "unicode": "U+1F1F2 U+1F1E8",
      "text": "Monaco",
      "value": "Monaco"
    },
    {
      "flag": "MD".toLowerCase(),
      "emoji": "🇲🇩",
      "unicode": "U+1F1F2 U+1F1E9",
      "text": "Moldova",
      "value": "Moldova"
    },
    {
      "flag": "ME".toLowerCase(),
      "emoji": "🇲🇪",
      "unicode": "U+1F1F2 U+1F1EA",
      "text": "Montenegro",
      "value": "Montenegro"
    },
    {
      // "flag": "MF".toLowerCase(),
      "emoji": "🇲🇫",
      "unicode": "U+1F1F2 U+1F1EB",
      "text": "Saint Martin (French Part)",
      "value": "Saint Martin (French Part)"
    },
    {
      "flag": "MG".toLowerCase(),
      "emoji": "🇲🇬",
      "unicode": "U+1F1F2 U+1F1EC",
      "text": "Madagascar",
      "value": "Madagascar"
    },
    {
      "flag": "MH".toLowerCase(),
      "emoji": "🇲🇭",
      "unicode": "U+1F1F2 U+1F1ED",
      "text": "Marshall Islands",
      "value": "Marshall Islands"
    },
    {
      "flag": "MK".toLowerCase(),
      "emoji": "🇲🇰",
      "unicode": "U+1F1F2 U+1F1F0",
      "text": "Macedonia",
      "value": "Macedonia"
    },
    {
      "flag": "ML".toLowerCase(),
      "emoji": "🇲🇱",
      "unicode": "U+1F1F2 U+1F1F1",
      "text": "Mali",
      "value": "Mali"
    },
    {
      "flag": "MM".toLowerCase(),
      "emoji": "🇲🇲",
      "unicode": "U+1F1F2 U+1F1F2",
      "text": "Myanmar",
      "value": "Myanmar"
    },
    {
      "flag": "MN".toLowerCase(),
      "emoji": "🇲🇳",
      "unicode": "U+1F1F2 U+1F1F3",
      "text": "Mongolia",
      "value": "Mongolia"
    },
    {
      "flag": "MO".toLowerCase(),
      "emoji": "🇲🇴",
      "unicode": "U+1F1F2 U+1F1F4",
      "text": "Macao",
      "value": "Macao"
    },
    {
      "flag": "MP".toLowerCase(),
      "emoji": "🇲🇵",
      "unicode": "U+1F1F2 U+1F1F5",
      "text": "Northern Mariana Islands",
      "value": "Northern Mariana Islands"
    },
    {
      "flag": "MQ".toLowerCase(),
      "emoji": "🇲🇶",
      "unicode": "U+1F1F2 U+1F1F6",
      "text": "Martinique",
      "value": "Martinique"
    },
    {
      "flag": "MR".toLowerCase(),
      "emoji": "🇲🇷",
      "unicode": "U+1F1F2 U+1F1F7",
      "text": "Mauritania",
      "value": "Mauritania"
    },
    {
      "flag": "MS".toLowerCase(),
      "emoji": "🇲🇸",
      "unicode": "U+1F1F2 U+1F1F8",
      "text": "Montserrat",
      "value": "Montserrat"
    },
    {
      "flag": "MT".toLowerCase(),
      "emoji": "🇲🇹",
      "unicode": "U+1F1F2 U+1F1F9",
      "text": "Malta",
      "value": "Malta"
    },
    {
      "flag": "MU".toLowerCase(),
      "emoji": "🇲🇺",
      "unicode": "U+1F1F2 U+1F1FA",
      "text": "Mauritius",
      "value": "Mauritius"
    },
    {
      "flag": "MV".toLowerCase(),
      "emoji": "🇲🇻",
      "unicode": "U+1F1F2 U+1F1FB",
      "text": "Maldives",
      "value": "Maldives"
    },
    {
      "flag": "MW".toLowerCase(),
      "emoji": "🇲🇼",
      "unicode": "U+1F1F2 U+1F1FC",
      "text": "Malawi",
      "value": "Malawi"
    },
    {
      "flag": "MX".toLowerCase(),
      "emoji": "🇲🇽",
      "unicode": "U+1F1F2 U+1F1FD",
      "text": "Mexico",
      "value": "Mexico"
    },
    {
      "flag": "MY".toLowerCase(),
      "emoji": "🇲🇾",
      "unicode": "U+1F1F2 U+1F1FE",
      "text": "Malaysia",
      "value": "Malaysia"
    },
    {
      "flag": "MZ".toLowerCase(),
      "emoji": "🇲🇿",
      "unicode": "U+1F1F2 U+1F1FF",
      "text": "Mozambique",
      "value": "Mozambique"
    },
    {
      "flag": "NA".toLowerCase(),
      "emoji": "🇳🇦",
      "unicode": "U+1F1F3 U+1F1E6",
      "text": "Namibia",
      "value": "Namibia"
    },
    {
      "flag": "NC".toLowerCase(),
      "emoji": "🇳🇨",
      "unicode": "U+1F1F3 U+1F1E8",
      "text": "New Caledonia",
      "value": "New Caledonia"
    },
    {
      "flag": "NE".toLowerCase(),
      "emoji": "🇳🇪",
      "unicode": "U+1F1F3 U+1F1EA",
      "text": "Niger",
      "value": "Niger"
    },
    {
      "flag": "NF".toLowerCase(),
      "emoji": "🇳🇫",
      "unicode": "U+1F1F3 U+1F1EB",
      "text": "Norfolk Island",
      "value": "Norfolk Island"
    },
    {
      "flag": "NG".toLowerCase(),
      "emoji": "🇳🇬",
      "unicode": "U+1F1F3 U+1F1EC",
      "text": "Nigeria",
      "value": "Nigeria"
    },
    {
      "flag": "NI".toLowerCase(),
      "emoji": "🇳🇮",
      "unicode": "U+1F1F3 U+1F1EE",
      "text": "Nicaragua",
      "value": "Nicaragua"
    },
    {
      "flag": "NL".toLowerCase(),
      "emoji": "🇳🇱",
      "unicode": "U+1F1F3 U+1F1F1",
      "text": "Netherlands",
      "value": "Netherlands"
    },
    {
      "flag": "NO".toLowerCase(),
      "emoji": "🇳🇴",
      "unicode": "U+1F1F3 U+1F1F4",
      "text": "Norway",
      "value": "Norway"
    },
    {
      "flag": "NP".toLowerCase(),
      "emoji": "🇳🇵",
      "unicode": "U+1F1F3 U+1F1F5",
      "text": "Nepal",
      "value": "Nepal"
    },
    {
      "flag": "NR".toLowerCase(),
      "emoji": "🇳🇷",
      "unicode": "U+1F1F3 U+1F1F7",
      "text": "Nauru",
      "value": "Nauru"
    },
    {
      "flag": "NU".toLowerCase(),
      "emoji": "🇳🇺",
      "unicode": "U+1F1F3 U+1F1FA",
      "text": "Niue",
      "value": "Niue"
    },
    {
      "flag": "NZ".toLowerCase(),
      "emoji": "🇳🇿",
      "unicode": "U+1F1F3 U+1F1FF",
      "text": "New Zealand",
      "value": "New Zealand"
    },
    {
      "flag": "OM".toLowerCase(),
      "emoji": "🇴🇲",
      "unicode": "U+1F1F4 U+1F1F2",
      "text": "Oman",
      "value": "Oman"
    },
    {
      "flag": "PA".toLowerCase(),
      "emoji": "🇵🇦",
      "unicode": "U+1F1F5 U+1F1E6",
      "text": "Panama",
      "value": "Panama"
    },
    {
      "flag": "PE".toLowerCase(),
      "emoji": "🇵🇪",
      "unicode": "U+1F1F5 U+1F1EA",
      "text": "Peru",
      "value": "Peru"
    },
    {
      "flag": "PF".toLowerCase(),
      "emoji": "🇵🇫",
      "unicode": "U+1F1F5 U+1F1EB",
      "text": "French Polynesia",
      "value": "French Polynesia"
    },
    {
      "flag": "PG".toLowerCase(),
      "emoji": "🇵🇬",
      "unicode": "U+1F1F5 U+1F1EC",
      "text": "Papua New Guinea",
      "value": "Papua New Guinea"
    },
    {
      "flag": "PH".toLowerCase(),
      "emoji": "🇵🇭",
      "unicode": "U+1F1F5 U+1F1ED",
      "text": "Philippines",
      "value": "Philippines"
    },
    {
      "flag": "PK".toLowerCase(),
      "emoji": "🇵🇰",
      "unicode": "U+1F1F5 U+1F1F0",
      "text": "Pakistan",
      "value": "Pakistan"
    },
    {
      "flag": "PL".toLowerCase(),
      "emoji": "🇵🇱",
      "unicode": "U+1F1F5 U+1F1F1",
      "text": "Poland",
      "value": "Poland"
    },
    {
      "flag": "PM".toLowerCase(),
      "emoji": "🇵🇲",
      "unicode": "U+1F1F5 U+1F1F2",
      "text": "Saint Pierre and Miquelon",
      "value": "Saint Pierre and Miquelon"
    },
    {
      "flag": "PN".toLowerCase(),
      "emoji": "🇵🇳",
      "unicode": "U+1F1F5 U+1F1F3",
      "text": "Pitcairn",
      "value": "Pitcairn"
    },
    {
      "flag": "PR".toLowerCase(),
      "emoji": "🇵🇷",
      "unicode": "U+1F1F5 U+1F1F7",
      "text": "Puerto Rico",
      "value": "Puerto Rico"
    },
    {
      "flag": "PS".toLowerCase(),
      "emoji": "🇵🇸",
      "unicode": "U+1F1F5 U+1F1F8",
      "text": "Palestinian Territory",
      "value": "Palestinian Territory"
    },
    {
      "flag": "PT".toLowerCase(),
      "emoji": "🇵🇹",
      "unicode": "U+1F1F5 U+1F1F9",
      "text": "Portugal",
      "value": "Portugal"
    },
    {
      "flag": "PW".toLowerCase(),
      "emoji": "🇵🇼",
      "unicode": "U+1F1F5 U+1F1FC",
      "text": "Palau",
      "value": "Palau"
    },
    {
      "flag": "PY".toLowerCase(),
      "emoji": "🇵🇾",
      "unicode": "U+1F1F5 U+1F1FE",
      "text": "Paraguay",
      "value": "Paraguay"
    },
    {
      "flag": "QA".toLowerCase(),
      "emoji": "🇶🇦",
      "unicode": "U+1F1F6 U+1F1E6",
      "text": "Qatar",
      "value": "Qatar"
    },
    {
      "flag": "RE".toLowerCase(),
      "emoji": "🇷🇪",
      "unicode": "U+1F1F7 U+1F1EA",
      "text": "Réunion",
      "value": "Réunion"
    },
    {
      "flag": "RO".toLowerCase(),
      "emoji": "🇷🇴",
      "unicode": "U+1F1F7 U+1F1F4",
      "text": "Romania",
      "value": "Romania"
    },
    {
      "flag": "RS".toLowerCase(),
      "emoji": "🇷🇸",
      "unicode": "U+1F1F7 U+1F1F8",
      "text": "Serbia",
      "value": "Serbia"
    },
    {
      "flag": "RU".toLowerCase(),
      "emoji": "🇷🇺",
      "unicode": "U+1F1F7 U+1F1FA",
      "text": "Russia",
      "value": "Russia"
    },
    {
      "flag": "RW".toLowerCase(),
      "emoji": "🇷🇼",
      "unicode": "U+1F1F7 U+1F1FC",
      "text": "Rwanda",
      "value": "Rwanda"
    },
    {
      "flag": "SA".toLowerCase(),
      "emoji": "🇸🇦",
      "unicode": "U+1F1F8 U+1F1E6",
      "text": "Saudi Arabia",
      "value": "Saudi Arabia"
    },
    {
      "flag": "SB".toLowerCase(),
      "emoji": "🇸🇧",
      "unicode": "U+1F1F8 U+1F1E7",
      "text": "Solomon Islands",
      "value": "Solomon Islands"
    },
    {
      "flag": "SC".toLowerCase(),
      "emoji": "🇸🇨",
      "unicode": "U+1F1F8 U+1F1E8",
      "text": "Seychelles",
      "value": "Seychelles"
    },
    {
      "flag": "SD".toLowerCase(),
      "emoji": "🇸🇩",
      "unicode": "U+1F1F8 U+1F1E9",
      "text": "Sudan",
      "value": "Sudan"
    },
    {
      "flag": "SE".toLowerCase(),
      "emoji": "🇸🇪",
      "unicode": "U+1F1F8 U+1F1EA",
      "text": "Sweden",
      "value": "Sweden"
    },
    {
      "flag": "SG".toLowerCase(),
      "emoji": "🇸🇬",
      "unicode": "U+1F1F8 U+1F1EC",
      "text": "Singapore",
      "value": "Singapore"
    },
    {
      "flag": "SH".toLowerCase(),
      "emoji": "🇸🇭",
      "unicode": "U+1F1F8 U+1F1ED",
      "text": "Saint Helena, Ascension and Tristan Da Cunha",
      "value": "Saint Helena, Ascension and Tristan Da Cunha"
    },
    {
      "flag": "SI".toLowerCase(),
      "emoji": "🇸🇮",
      "unicode": "U+1F1F8 U+1F1EE",
      "text": "Slovenia",
      "value": "Slovenia"
    },
    {
      "flag": "SJ".toLowerCase(),
      "emoji": "🇸🇯",
      "unicode": "U+1F1F8 U+1F1EF",
      "text": "Svalbard and Jan Mayen",
      "value": "Svalbard and Jan Mayen"
    },
    {
      "flag": "SK".toLowerCase(),
      "emoji": "🇸🇰",
      "unicode": "U+1F1F8 U+1F1F0",
      "text": "Slovakia",
      "value": "Slovakia"
    },
    {
      "flag": "SL".toLowerCase(),
      "emoji": "🇸🇱",
      "unicode": "U+1F1F8 U+1F1F1",
      "text": "Sierra Leone",
      "value": "Sierra Leone"
    },
    {
      "flag": "SM".toLowerCase(),
      "emoji": "🇸🇲",
      "unicode": "U+1F1F8 U+1F1F2",
      "text": "San Marino",
      "value": "San Marino"
    },
    {
      "flag": "SN".toLowerCase(),
      "emoji": "🇸🇳",
      "unicode": "U+1F1F8 U+1F1F3",
      "text": "Senegal",
      "value": "Senegal"
    },
    {
      "flag": "SO".toLowerCase(),
      "emoji": "🇸🇴",
      "unicode": "U+1F1F8 U+1F1F4",
      "text": "Somalia",
      "value": "Somalia"
    },
    {
      "flag": "SR".toLowerCase(),
      "emoji": "🇸🇷",
      "unicode": "U+1F1F8 U+1F1F7",
      "text": "Suriname",
      "value": "Suriname"
    },
    {
      // "flag": "SS".toLowerCase(),
      "emoji": "🇸🇸",
      "unicode": "U+1F1F8 U+1F1F8",
      "text": "South Sudan",
      "value": "South Sudan"
    },
    {
      "flag": "ST".toLowerCase(),
      "emoji": "🇸🇹",
      "unicode": "U+1F1F8 U+1F1F9",
      "text": "Sao Tome and Principe",
      "value": "Sao Tome and Principe"
    },
    {
      "flag": "SV".toLowerCase(),
      "emoji": "🇸🇻",
      "unicode": "U+1F1F8 U+1F1FB",
      "text": "El Salvador",
      "value": "El Salvador"
    },
    {
      // "flag": "SX".toLowerCase(),
      "emoji": "🇸🇽",
      "unicode": "U+1F1F8 U+1F1FD",
      "text": "Sint Maarten (Dutch Part)",
      "value": "Sint Maarten (Dutch Part)"
    },
    {
      "flag": "SY".toLowerCase(),
      "emoji": "🇸🇾",
      "unicode": "U+1F1F8 U+1F1FE",
      "text": "Syrian Arab Republic",
      "value": "Syrian Arab Republic"
    },
    {
      "flag": "SZ".toLowerCase(),
      "emoji": "🇸🇿",
      "unicode": "U+1F1F8 U+1F1FF",
      "text": "Swaziland",
      "value": "Swaziland"
    },
    {
      "flag": "TC".toLowerCase(),
      "emoji": "🇹🇨",
      "unicode": "U+1F1F9 U+1F1E8",
      "text": "Turks and Caicos Islands",
      "value": "Turks and Caicos Islands"
    },
    {
      "flag": "TD".toLowerCase(),
      "emoji": "🇹🇩",
      "unicode": "U+1F1F9 U+1F1E9",
      "text": "Chad",
      "value": "Chad"
    },
    {
      "flag": "TF".toLowerCase(),
      "emoji": "🇹🇫",
      "unicode": "U+1F1F9 U+1F1EB",
      "text": "French Southern Territories",
      "value": "French Southern Territories"
    },
    {
      "flag": "TG".toLowerCase(),
      "emoji": "🇹🇬",
      "unicode": "U+1F1F9 U+1F1EC",
      "text": "Togo",
      "value": "Togo"
    },
    {
      "flag": "TH".toLowerCase(),
      "emoji": "🇹🇭",
      "unicode": "U+1F1F9 U+1F1ED",
      "text": "Thailand",
      "value": "Thailand"
    },
    {
      "flag": "TJ".toLowerCase(),
      "emoji": "🇹🇯",
      "unicode": "U+1F1F9 U+1F1EF",
      "text": "Tajikistan",
      "value": "Tajikistan"
    },
    {
      "flag": "TK".toLowerCase(),
      "emoji": "🇹🇰",
      "unicode": "U+1F1F9 U+1F1F0",
      "text": "Tokelau",
      "value": "Tokelau"
    },
    {
      "flag": "TL".toLowerCase(),
      "emoji": "🇹🇱",
      "unicode": "U+1F1F9 U+1F1F1",
      "text": "Timor-Leste",
      "value": "Timor-Leste"
    },
    {
      "flag": "TM".toLowerCase(),
      "emoji": "🇹🇲",
      "unicode": "U+1F1F9 U+1F1F2",
      "text": "Turkmenistan",
      "value": "Turkmenistan"
    },
    {
      "flag": "TN".toLowerCase(),
      "emoji": "🇹🇳",
      "unicode": "U+1F1F9 U+1F1F3",
      "text": "Tunisia",
      "value": "Tunisia"
    },
    {
      "flag": "TO".toLowerCase(),
      "emoji": "🇹🇴",
      "unicode": "U+1F1F9 U+1F1F4",
      "text": "Tonga",
      "value": "Tonga"
    },
    {
      "flag": "TR".toLowerCase(),
      "emoji": "🇹🇷",
      "unicode": "U+1F1F9 U+1F1F7",
      "text": "Turkey",
      "value": "Turkey"
    },
    {
      "flag": "TT".toLowerCase(),
      "emoji": "🇹🇹",
      "unicode": "U+1F1F9 U+1F1F9",
      "text": "Trinidad and Tobago",
      "value": "Trinidad and Tobago"
    },
    {
      "flag": "TV".toLowerCase(),
      "emoji": "🇹🇻",
      "unicode": "U+1F1F9 U+1F1FB",
      "text": "Tuvalu",
      "value": "Tuvalu"
    },
    {
      "flag": "TW".toLowerCase(),
      "emoji": "🇹🇼",
      "unicode": "U+1F1F9 U+1F1FC",
      "text": "Taiwan",
      "value": "Taiwan"
    },
    {
      "flag": "TZ".toLowerCase(),
      "emoji": "🇹🇿",
      "unicode": "U+1F1F9 U+1F1FF",
      "text": "Tanzania",
      "value": "Tanzania"
    },
    {
      "flag": "UA".toLowerCase(),
      "emoji": "🇺🇦",
      "unicode": "U+1F1FA U+1F1E6",
      "text": "Ukraine",
      "value": "Ukraine"
    },
    {
      "flag": "UG".toLowerCase(),
      "emoji": "🇺🇬",
      "unicode": "U+1F1FA U+1F1EC",
      "text": "Uganda",
      "value": "Uganda"
    },
    {
      "flag": "UM".toLowerCase(),
      "emoji": "🇺🇲",
      "unicode": "U+1F1FA U+1F1F2",
      "text": "United States Minor Outlying Islands",
      "value": "United States Minor Outlying Islands"
    },
    {
      "flag": "US".toLowerCase(),
      "emoji": "🇺🇸",
      "unicode": "U+1F1FA U+1F1F8",
      "text": "United States",
      "value": "United States"
    },
    {
      "flag": "UY".toLowerCase(),
      "emoji": "🇺🇾",
      "unicode": "U+1F1FA U+1F1FE",
      "text": "Uruguay",
      "value": "Uruguay"
    },
    {
      "flag": "UZ".toLowerCase(),
      "emoji": "🇺🇿",
      "unicode": "U+1F1FA U+1F1FF",
      "text": "Uzbekistan",
      "value": "Uzbekistan"
    },
    {
      "flag": "VA".toLowerCase(),
      "emoji": "🇻🇦",
      "unicode": "U+1F1FB U+1F1E6",
      "text": "Vatican City",
      "value": "Vatican City"
    },
    {
      "flag": "VC".toLowerCase(),
      "emoji": "🇻🇨",
      "unicode": "U+1F1FB U+1F1E8",
      "text": "Saint Vincent and The Grenadines",
      "value": "Saint Vincent and The Grenadines"
    },
    {
      "flag": "VE".toLowerCase(),
      "emoji": "🇻🇪",
      "unicode": "U+1F1FB U+1F1EA",
      "text": "Venezuela",
      "value": "Venezuela"
    },
    {
      "flag": "VG".toLowerCase(),
      "emoji": "🇻🇬",
      "unicode": "U+1F1FB U+1F1EC",
      "text": "Virgin Islands, British",
      "value": "Virgin Islands, British"
    },
    {
      "flag": "VI".toLowerCase(),
      "emoji": "🇻🇮",
      "unicode": "U+1F1FB U+1F1EE",
      "text": "Virgin Islands, U.S.",
      "value": "Virgin Islands, U.S."
    },
    {
      "flag": "VN".toLowerCase(),
      "emoji": "🇻🇳",
      "unicode": "U+1F1FB U+1F1F3",
      "text": "Viet Nam",
      "value": "Viet Nam"
    },
    {
      "flag": "VU".toLowerCase(),
      "emoji": "🇻🇺",
      "unicode": "U+1F1FB U+1F1FA",
      "text": "Vanuatu",
      "value": "Vanuatu"
    },
    {
      "flag": "WF".toLowerCase(),
      "emoji": "🇼🇫",
      "unicode": "U+1F1FC U+1F1EB",
      "text": "Wallis and Futuna",
      "value": "Wallis and Futuna"
    },
    {
      "flag": "WS".toLowerCase(),
      "emoji": "🇼🇸",
      "unicode": "U+1F1FC U+1F1F8",
      "text": "Samoa",
      "value": "Samoa"
    },
    {
      "flag": "YE".toLowerCase(),
      "emoji": "🇾🇪",
      "unicode": "U+1F1FE U+1F1EA",
      "text": "Yemen",
      "value": "Yemen"
    },
    {
      "flag": "YT".toLowerCase(),
      "emoji": "🇾🇹",
      "unicode": "U+1F1FE U+1F1F9",
      "text": "Mayotte",
      "value": "Mayotte"
    },
    {
      "flag": "ZA".toLowerCase(),
      "emoji": "🇿🇦",
      "unicode": "U+1F1FF U+1F1E6",
      "text": "South Africa",
      "value": "South Africa"
    },
    {
      "flag": "ZM".toLowerCase(),
      "emoji": "🇿🇲",
      "unicode": "U+1F1FF U+1F1F2",
      "text": "Zambia",
      "value": "Zambia"
    },
    {
      "flag": "ZW".toLowerCase(),
      "emoji": "🇿🇼",
      "unicode": "U+1F1FF U+1F1FC",
      "text": "Zimbabwe",
      "value": "Zimbabwe"
    }
  ]
